<script setup>
// Redes sociais no canvas: os mesmos ícones do e-mail; item ainda sem link
// aparece apagado (no e-mail ele não sai).
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { hasLink, iconUrl } from '../../document/social';

const props = defineProps({ element: { type: Object, required: true } });
defineOptions({ inheritAttrs: false });
const { t } = useI18n();
const st = computed(() => props.element.style || {});
const items = computed(() => props.element.items || []);
const JUSTIFY = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};
</script>

<template>
  <div class="flex" :class="JUSTIFY[st.align] || 'justify-center'">
    <div
      v-if="items.length"
      class="flex flex-wrap"
      :style="{ gap: `${st.gap ?? 12}px` }"
    >
      <img
        v-for="(item, i) in items"
        :key="`${item.network}-${i}`"
        :src="iconUrl(st.icon_style, item.network)"
        :alt="item.network"
        :width="st.size || 32"
        :height="st.size || 32"
        :title="
          hasLink(item.url)
            ? item.url
            : t('EMAIL_TEMPLATES.EDITOR.SOCIAL.NO_LINK')
        "
        class="block select-none"
        :class="hasLink(item.url) ? '' : 'opacity-30'"
        draggable="false"
      />
    </div>
    <p v-else class="py-3 text-xs text-n-slate-10">
      {{ t('EMAIL_TEMPLATES.EDITOR.SOCIAL.EMPTY') }}
    </p>
  </div>
</template>
